import { apiClient } from "../../services/api";
import { gaEventAcquisitionChannelSubmitted } from "../../tools/analytics/domains/onboarding.analytics";
import { reloadCurrentUser } from "./hooks/useCurrentUser";
import type { AcquisitionChannelValue } from "./utils/acquisitionChannels";

/**
 * Write the answer to "How did you hear about us?". Shared by the desktop
 * corner card and the phone's chat card, so that the two cannot send different
 * requests or report different events.
 *
 * The event fires only once the answer is stored. The user is reloaded last:
 * both cards render while `acquisitionChannel` is null, so the reload is what
 * retires them.
 */
export async function saveAcquisitionChannel(
  channel: AcquisitionChannelValue
): Promise<"saved" | "failed"> {
  try {
    await apiClient.patch("/webapp/private/users/me", {
      json: { acquisitionChannel: channel, acquisitionChannelOther: null },
    });
  } catch {
    return "failed";
  }
  gaEventAcquisitionChannelSubmitted({ channel });
  await reloadCurrentUser();
  return "saved";
}
